import { Text, Flex } from '@mantine/core';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ScoreBadge from '@/components/shared/ScoreBadge';
import BaseClickable from '@/components/ui/BaseClickable';
import { ROUTES } from '@/configs/routes';
import { useDevices } from '@/utils/devices';

import { NewsItemProps } from './types';

import s from './NewsItem.module.scss';

const NewsItem: React.FC<NewsItemProps> = ({ model }) => {
  const { isCompactViewport } = useDevices();
  const navigate = useNavigate();
  const { id, newsId } = useParams();

  const handleClick = React.useCallback(() => {
    const state = isCompactViewport
      ? {
          newsUpdatedAt: model.updatedAt,
          newsPublishDate: model.publishDate,
        }
      : undefined;

    navigate(ROUTES.organization.news.article.create(String(id), String(model.id)), {
      state: state,
    });
  }, [id, isCompactViewport, model.id, model.publishDate, model.updatedAt, navigate]);

  const isActive = newsId === String(model.id);

  const combinedScore = 'combinedScore' in model ? model.combinedScore : undefined;

  return (
    <BaseClickable className={cn(s.root, isActive && s.root_active)} onClick={handleClick}>
      <Flex justify="space-between" align="center" className={s.root__header}>
        <Text size="xs" lh="xxs">
          {model.publishDate}
        </Text>
        <Flex gap="xs" align="center" justify="flex-end" wrap="wrap">
          {combinedScore && <ScoreBadge label="Релевантность" value={combinedScore} />}
        </Flex>
      </Flex>
      <Text size={isCompactViewport ? 'sm' : 'xs'} lh={isCompactViewport ? 'xs' : 'sm'} fw={600} lineClamp={3}>
        {model.title}
      </Text>
    </BaseClickable>
  );
};

export default observer(NewsItem);
